import { useMeQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { useProductLimitSchemas } from "../../products/productsHooks";
import { useEffect, useState } from 'react';
import { Box, Button, Heading, useTombac } from 'tombac';
import { DeleteIcon, EditIcon } from 'tombac-icons';
import DeleteLimitsModal from "./DeleteLimitsModal";
import LimitsModal from "./LimitsModal";
import "./LimitsSummary.css";
import { LimitSummaryList } from "./LimitSummaryList";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function LimitsSummary({
  isEditOpen = false,
  onRequestEditClose,
  onRequestEditOpen,
  productValues,
  readOnly,
  packages,
  contractId
}) {
  const tombac = useTombac();
  const me = useMeQuery().data.me;
  const {
    product,
    limits: loadedLimits,
    usage
  } = productValues;
  const schemas = useProductLimitSchemas({
    productId: product.id
  });
  const [trashModalOpen, setTrashModalOpen] = useState(false);
  const [limits, setLimits] = useState(null);
  const sharedWith = Object.keys(packages.limits);
  useEffect(() => {
    let limits = null;
    if (loadedLimits && schemas) {
      limits = {};
      schemas.forEach(({
        customizable,
        name,
        type
      }) => {
        if (type !== 'BOOLEAN' && Object.hasOwn(loadedLimits, name) && customizable && loadedLimits[name] !== undefined && loadedLimits[name] !== null && (me.role !== UserRole.Admin || !sharedWith.find(i => i.includes(name)))) limits[name] = loadedLimits[name];
      });
    }
    setLimits(limits);
  }, [loadedLimits, schemas]);
  const handleEditClose = () => {
    onRequestEditClose();
  };
  const handleTrashClose = () => {
    setTrashModalOpen(false);
  };
  const limitsExist = limits && Object.values(limits).length > 0;
  return schemas && schemas.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      $borderBottom: "1u solid --neutral-400",
      $display: "flex",
      $flex: "auto",
      $gridColumn: "2",
      $pb: "1sp",
      children: [/*#__PURE__*/_jsx(Heading, {
        $flex: "auto",
        as: "h4",
        fontSize: 12,
        level: 5,
        children: "Usage limits"
      }), !readOnly && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: () => onRequestEditOpen(),
          shape: "circle",
          size: "xs",
          variant: "flat",
          children: /*#__PURE__*/_jsx(EditIcon, {})
        }), limitsExist && /*#__PURE__*/_jsx(Button, {
          $ml: "0.5sp",
          onClick: () => setTrashModalOpen(true),
          shape: "circle",
          size: "xs",
          variant: "flat",
          children: /*#__PURE__*/_jsx(DeleteIcon, {
            color: tombac.color('danger')
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      $gridColumn: "2",
      children: [/*#__PURE__*/_jsx(LimitSummaryList, {
        $flex: "1",
        limits: limits,
        schemas: schemas,
        usages: usage
      }), /*#__PURE__*/_jsx(LimitsModal, {
        configurator: {
          onRequestClose: handleEditClose,
          productValues,
          packages,
          contractId
        },
        isOpen: isEditOpen
      }), /*#__PURE__*/_jsx(DeleteLimitsModal, {
        isOpen: trashModalOpen,
        onRequestClose: handleTrashClose,
        product: product,
        contractId: contractId
      })]
    })]
  }) : null;
}